import { NumberOrUndefinedInput, NumberOrUndefinedInputProps } from "../elements/NumberOrUndefinedInput";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = NumberOrUndefinedInputProps & FormItemProps<number | undefined>;

export const FormNumberOrUndefinedInput = (props: Props) => {
  return (
    <FormItemContainer<number | undefined> {...props}>
      <NumberOrUndefinedInput {...props} />
    </FormItemContainer>
  );
};
